import React, { FunctionComponent, SVGAttributes } from 'react';
import { Svg } from '../../SvgOptimizer/Svg';

const Baseline: FunctionComponent<SVGAttributes<SVGSVGElement>> = (props) => (
  <Svg
    optimizationId="iconsArrowBackIosBaseline"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z" />
  </Svg>
);

Baseline.displayName = 'ArrowBackIosBaseline';

export default Baseline;
